import { Injectable } from '@angular/core';
import { CreateUserDto, FindUserDto, PageResultDto, UserDto } from '../../@api/dto';
import { HttpService } from '../../@api/services';

@Injectable()
export class UserService {
  constructor(
    private httpService: HttpService
  ) { }

  async find(findUserDto: FindUserDto) {
    return await this.httpService.get<PageResultDto<UserDto>>('/merchant/v1/users', findUserDto)
  }

  async findDeleted(findUserDto: FindUserDto) {
    return await this.httpService.get<PageResultDto<UserDto>>('/merchant/v1/users/deleted-customers', findUserDto)
  }

  async findOne(id: string) {
    return await this.httpService.get<UserDto>(`/merchant/v1/users/${id}`)
  }

  async setEnabled(id: string, enabled: boolean) {
    if (enabled) {
      return await this.httpService.patch(`/merchant/v1/users/${id}/enable`)
    }
    
    return await this.httpService.patch(`/merchant/v1/users/${id}/disable`)
  }

  async export(findUserDto: FindUserDto) {
    return await this.httpService.get<any>(`/merchant/v1/users/export`, findUserDto)
  }

  async changePassword(id: string, newPassword: string) {
    return await this.httpService.patch(`/merchant/v1/users/${id}/password`, { password: newPassword })
  }

  async findByIds(ownerIds: string[]) {
    return await this.httpService.get<UserDto[]>(`/merchant/v1/users/ids`, { ownerIds })
  }

  async create(createUserDto: CreateUserDto) {
    return await this.httpService.post<UserDto>('/merchant/v1/users', createUserDto)
  }

  async delete(id: string) {
    return await this.httpService.delete<Boolean>(`/merchant/v1/users/${id}`)
  }

}
